<template>
  <div style="height: 100%">
    <div class="buttonBox" v-if="showButton">
      <div>
        <div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')"
             v-if="MenuRoleList.indexOf('30')>=0"><i
          class="el-icon-circle-plus-outline"></i>{{$t('btn_17')}}
        </div>
        <div class="chooseButton deleteButton" @click="delEquipmentTypePartInfo" v-if="MenuRoleList.indexOf('31')>=0"><i
          class="el-icon-delete"></i>{{$t('btn_18')}}
        </div>
      </div>
    </div>
    <el-table
      :empty-text="$t('label_357')"
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      @current-change="handleCurrentChangeTree"
      border
      style="width: 100%;margin:  10px 0 10px 0px" height="87%"
      :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
      <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
                       width="50">
      </el-table-column>
      <el-table-column
        prop="type"
        :label="$t('label_331')" align="center">
        <template slot-scope="scope">
          {{checkText(scope.row.type)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('label_664')" align="center">
      </el-table-column>
      <el-table-column
        prop="maker"
        :label="$t('label_672')" align="center">
      </el-table-column>
      <el-table-column
        prop="model"
        :label="$t('label_666')" align="center">
      </el-table-column>
    </el-table>
    <Page class="item" ref="pageModel" :total="pageCount"
          :display="pageSize" :pagegroup="3" :currentspage="1"
          @parentMethod="searchPage"></Page>

    <el-dialog
      :title="deviceParamTitle"
      :visible.sync="dialogDeviceSpot" append-to-body
      :close-on-click-modal='false'
      width="800px"
      top="2%"
      :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <div class="dialogMes">
            <p>{{$t('label_664')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.name" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 30px">
            <p>{{$t('label_331')}}</p>
            <div class="mesInput">
              <el-select v-model="tableDataEdit.type" filterable :placeholder="$t('input_65')" clearable>
                <el-option
                  v-for="item in checkList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p>{{$t('label_666')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.model" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 30px">
            <p>{{$t('label_672')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.maker" clearable></el-input>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: space-between">
        <div class="buttonBox">
          <div class="chooseButton searchButton" style="width: 110px;margin-left: 0" @click="confirm">{{$t('btn_39')}}</div>
        </div>
        <div class="buttonBox">
          <div class="chooseButton sendButton" style="width: 110px;" @click="deviceCheckItemInfoEdit('1')">
            <i class="el-icon-search"></i>{{$t('btn_2')}}
          </div>
        </div>
      </div>
      <el-table
        ref="singleTable"
        :data="tableDatadialog"
        highlight-current-row
        @current-change="handleCurrentChangeTree"
        @selection-change="handleSelectionChange"
        border
        height="530"
        style="width: 100%;margin: 10px 0;overflow: auto;"
        :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
        <el-table-column
          type="selection"
          width="55" align="center">
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
                         width="50">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('label_331')" align="center">
          <template slot-scope="scope">
            {{checkText(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('label_664')" align="center">
        </el-table-column>
        <el-table-column
          prop="maker"
          :label="$t('label_672')" align="center">
        </el-table-column>
        <el-table-column
          prop="model"
          :label="$t('label_666')" align="center">
        </el-table-column>
      </el-table>
      <!--      <Page class="item" ref="pageModel" :total="pageCountDialog"
                  :display="pageSizeDialog" :pagegroup="3" :currentspage="1"
                  @parentMethod="searchPageDialog"></Page> -->
      <span slot="footer" class="dialog-footer">
	  </span>
    </el-dialog>
  </div>
</template>

<script>
  import file from "@/assets/js/file/file.js";
  import Page from "@/components/common/page";
  import utils from '@/utils/utils'

  export default {
    name: "maintenanceItem",
    components: {
      Page,
    },
    props: {
      showButton: {
        type: Boolean,
        default: ''
      },
      needSort: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        tableDatadialog: [],
        pageNum: 1,
        pageNumDialog: 1,
        pageSize: 10,
        pageSizeDialog: 10,
        MenuRoleList: [],
        tableDataEdit: {
          changeState: 0,
          content: "",
          cycle: "",
          cycleType: '1',
          decimals: 0,
          defaultValue: "string",
          equipmentTypeId: '',
          fileId: '',
          inputType: '1',
          length: 0,
          method: '',
          name: "",
          needPhoto: 0,
          maker: '',
          needPhotoNum: 5,
          needVideo: 0,
          needVideoNum: 1,
          pid: 0,
          remark: "string",
          sort: 0,
          unit: "string",
          weekend: '0',
          month: this.$t('label_245'),
          monthD: '1',
          monthDMes: '1',
        },
        pageCount: 0,
        pageCountDialog: 0,
        deviceParamTitle: this.$t('btn_14'),
        dialogDeviceSpot: false,
        checked: true,
        tableData: [],
        allDeviceData: [],
        checkList: [],
        tableDataTreeInfo: {},
        weekendMesOptions: [{
          value: '0',
          label: this.$t('label_719')
        }, {
          value: '1',
          label: this.$t('label_719')
        }, {
          value: '2',
          label: this.$t('label_723')
        }, {
          value: '3',
          label: this.$t('label_725')
        }, {
          value: '4',
          label: this.$t('label_728')
        }, {
          value: '5',
          label: this.$t('label_730')
        }, {
          value: '6',
          label: this.$t('label_716')
        }, ],
        monthDOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
        monthOptionsObj: {
          // '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
          // '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
          // '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        },
        searchDataList: {
          equipmentId: '',
          equipmentTypeId: ''
        },
        multipleSelection: [],
        confirmList: []
      }
    },
    methods: {
      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      changeSelectMonth() {
        this.tableDataEdit.monthD = '';
        for (const k in this.monthOptions) {
          if (this.tableDataEdit.month === this.monthOptions[k]) {
            this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
          }
        }
      },
      newMes(id) {
        this.searchDataList.equipmentTypeId = id;
      },
      handleCurrentChangeTree(info) {
        this.tableDataTreeInfo = info;
      },
      searchPage(param) {
        let dataParam = this.searchDataList;
        var newParam = Object.assign(param, dataParam);
        this.pageNum = newParam.pageNum;
        this.pageSize = newParam.pageSize;
        this.$refs['pageModel'].setCurrent(this.pageNum);
        this.getEquipmentPartInfo(newParam)
      },
      searchPageDialog(param) {
        var dataParam = this.searchDataList;
        var newParam = Object.assign(param, dataParam);
        this.pageNumDialog = newParam.pageNum;
        this.pageSizeDialog = newParam.pageSize;
        this.getEquipmentPartInfo(newParam)
      },
      checkText(type) {
        var data = this.checkList.filter(function (item) {
          return item.key == type;
        });
        if (data != '') {
          return data[0].val
        }
      },
      getCheckList() {
        file.getByDictIdALL({dictId: 3, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.checkList = data.data;
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getPartsList().then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
      },
      handleClose() {
        this.dialogDeviceSpot = false;
      },
      checkTypeText(type) {
        if (type == '1') {
          return this.$t('label_145')
        }
        if (type == '2') {
          return this.$t('label_149')
        }
        if (type == '3') {
          return this.$t('label_141')
        }
        if (type == '4') {
          return this.$t('label_138')
        }
      },
      getEquipmentPartInfo(param) {
        file.getEquipmentTypePartInfo(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableData = data.data.records;
            this.pageSize = data.data.size;
            this.pageCount = data.data.total;
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      deviceCheckItemInfoEdit(title) {
        // if (title == '2') {
        //   if (Object.keys(this.tableDataTreeInfo).length > 0) {
        //     file.getEquipmentTypeParameterMes(this.tableDataTreeInfo.id).then((response) => {
        //       const data = response.data;
        //       if (data.code == "1") {
        //         this.deviceParamTitle = '备件信息编辑';
        //         this.tableParamDataEdit = data.data;
        //         this.tableParamDataEdit.type = this.tableParamDataEdit.type.toString()
        //         this.dialogDeviceSpot = true;
        //       } else {
        //         utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        //       }
        //     }).catch((response) => {
        //       console.log(response)
        //     })
        //   } else {
        //     utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        //   }
        // } else {
        //   this.dialogDeviceSpot = true;
        //   this.deviceParamTitle = '备件信息新增';
        // }
        file.getEquipmentParts(this.tableDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDatadialog = data.data;
            this.dialogDeviceSpot = true;
            this.deviceParamTitle = this.$t('btn_14');
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      tableParamDataEditSave() {
        if (this.deviceParamTitle == this.$t('btn_14')) {
          this.tableParamDataEdit.sort = this.pageCount + 1;
          this.tableParamDataEdit.equipmentTypeId = this.searchDataList.equipmentTypeId;
          if (this.tableParamDataEdit.required) {
            this.tableParamDataEdit.required = 1;
          } else {
            this.tableParamDataEdit.required = 0;
          }
          file.saveEquipmentTypeParameter(this.tableParamDataEdit).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.dialogDeviceSpot = false;
              this.search();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          file.saveEquipmentTypeParameterEdit(this.tableParamDataEdit).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.dialogDeviceParam = false;
              this.search();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }
      },
      delEquipmentTypePartInfo() {
        let param = this.tableDataTreeInfo.id;
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning'
          }).then(() => {
            file.delEquipmentTypePartInfo(param).then((response) => {
              const data = response.data;
              if (data.code == 1) {
                let param1 = {
                  pageNum: 1,
                  pageSize: this.pageSize,
                }
                this.searchPage(param1);
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          }).catch(() => {

          });
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (var i = 0; i < val.length; i++) {
          this.multipleSelection.push(val[i].id);
        }
      },
      confirm() {
        if (this.multipleSelection.length > 0) {
          console.log(this.searchDataList.equipmentTypeId)
          this.confirmList = {
            equipmentTypeId: this.searchDataList.equipmentTypeId,
            partId: this.multipleSelection
          }
          file.confirmPartInfo(this.confirmList).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.dialogDeviceSpot = false;
              let param1 = {
                pageNum: 1,
                pageSize: this.pageSize,
              }
              this.searchPage(param1);
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      }
    },
    created() {
      this.getCheckList();
      this.MenuRoleList = this.$store.getters.getMenu;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/partInfo.vue